/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Attach_TypesInputs */

const vi_grower_attach_types = /** @type {(inputs: Grower_Attach_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh, PDF, Word, Excel — tối đa 20MB mỗi tệp`)
};

/**

* @param {Grower_Attach_TypesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_attach_types = /** @type {((inputs?: Grower_Attach_TypesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Attach_TypesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_attach_types(inputs)
});